import { render } from "./SpecialtyRegistries.vue?vue&type=template&id=7a700992&scoped=true"
import script from "./SpecialtyRegistries.vue?vue&type=script&lang=js"
export * from "./SpecialtyRegistries.vue?vue&type=script&lang=js"

import "./SpecialtyRegistries.vue?vue&type=style&index=0&id=7a700992&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a700992"]])

export default __exports__